<template>
    <div id="device-edit-view" class="device-edit__view">

        <device-form :handler="editDevice" :form="this.form" :is-edit-mode="true"></device-form>

        <br /><br />

        <div class="form">
            <v-layout>
                <v-flex xs12>
                    <v-layout row>
                        <v-flex md12>
                            <div class="content-wrapper">
                                <div class="info-block">
                                    Reassign device
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex md4>
                            <div class="content-wrapper">
                                <v-form
                                    ref="formOrganization"
                                    v-model="validOrganization"
                                    lazy-validation
                                >
                                    <v-layout row>
                                        <v-flex xs4>
                                            <div class="label text-xs-right">
                                                <span class="text-xs-right">Organization</span>
                                            </div>
                                        </v-flex>
                                        <v-flex xs8>
                                            <organization-autocomplete
                                                class="organization-autocomplete"
                                                v-model="formOrganization.organization"
                                                :disabled="!(!form.fleet && !form.vehicle)"
                                            ></organization-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex md12 class="">
                                            <div class="content-wrapper text-xs-right">
                                                <sp-button @click.native="validateOrganization" :disabled="!(!form.fleet && !form.vehicle)" text="Save" icon="download"></sp-button>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-form>
                            </div>
                        </v-flex>
                        <v-flex md4>
                            <div class="content-wrapper">
                                <v-form
                                    ref="formFleet"
                                    v-model="validFleet"
                                    lazy-validation
                                >
                                    <v-layout row>
                                        <v-flex xs4>
                                            <div class="label text-xs-right">
                                                <span class="text-xs-right">Fleet</span>
                                            </div>
                                        </v-flex>
                                        <v-flex xs8>
                                            <fleet-autocomplete
                                                v-model="formFleet.fleet"
                                                :organization="form.organization"
                                                :disabled="!(!!form.organization && !form.vehicle)"
                                            ></fleet-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex md12 class="">
                                            <div class="content-wrapper text-xs-right">
                                                <sp-button @click.native="validateFleet" :disabled="!(!!form.organization && !form.vehicle)" text="Save" icon="download"></sp-button>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-form>
                            </div>
                        </v-flex>
                        <v-flex md4>
                            <div class="content-wrapper">
                                <v-form
                                    ref="formVehicle"
                                    v-model="validVehicle"
                                    lazy-validation
                                >
                                    <v-layout row>
                                        <v-flex xs4>
                                            <div class="label text-xs-right">
                                                <span class="text-xs-right">Vehicle</span>
                                            </div>
                                        </v-flex>
                                        <v-flex xs8>
                                            <vehicle-autocomplete
                                                v-model="formVehicle.vehicle"
                                                :fleet="form.fleet"
                                                :disabled="!(!!form.fleet && !!form.organization)"
                                            ></vehicle-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex md12 class="">
                                            <div class="content-wrapper text-xs-right">
                                                <sp-button @click.native="validateVehicle" :disabled="!(!!form.fleet && !!form.organization)" text="Save" icon="download"></sp-button>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-form>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </div>
        <sp-loader v-if="isLoading"></sp-loader>
    </div>
</template>

<script>
import DeviceForm from '@/views/Devices/components/DeviceForm'
import toast from '@/plugins/izitoast'
import SpButton from '@/components/forms/Button'
import DeviceApi from '@/api/DeviceApi'
import VehicleAutocomplete from '@/views/Vehicles/components/VehicleAutocomplete'
import { arrayToBitFlag, bitFlagToArray } from '@/helpers/Utils'
import FleetAutocomplete from '@/views/Fleets/components/FleetAutocomplete'
import OrganizationAutocomplete from '@/views/Organizations/components/OrganizationAutocomplete'
import SpLoader from '@/components/atoms/Loader'

const deviceApi = new DeviceApi()

export default {
    name: 'DeviceEdit',
    async created () {
        this.uuid = this.$route.params.deviceUuid
        await this.getDevice()
        this.form.vehicle = this.formVehicle.vehicle
    },
    components: {
        FleetAutocomplete,
        VehicleAutocomplete,
        OrganizationAutocomplete,
        SpButton,
        DeviceForm,
        SpLoader
    },
    data () {
        return {
            isLoading: false,
            validOrganization: false,
            validFleet: false,
            validVehicle: false,
            form: {
                dataToCapture: [],
                channels: [],
                hardwareId: '',
                firmwareVersion: '',
                simNumber: '',
                serialNumber: '',
                deviceModelId: '',
                deviceProtocolId: '',
                customerSim: false,
                enabled: false,
                automaticVideoDownload: false,
                fleet: null,
                vehicle: null,
                organization: null
            },
            formVehicle: {
                vehicle: null
            },
            formFleet: {
                fleet: null
            },
            formOrganization: {
                organization: null
            }
        }
    },
    computed: {
    },
    methods: {
        async getDevice () {
            this.isLoading = true
            const response = await deviceApi.getDevice(this.uuid)

            this.form.channels = bitFlagToArray(response.payload.channelFlag)
            this.form.hardwareId = response.payload.hardwareId
            this.form.firmwareVersion = response.payload.firmwareVersion
            this.form.simNumber = response.payload.simNumber
            this.form.serialNumber = response.payload.serialNumber
            this.form.deviceModelId = response.payload.deviceModel ? response.payload.deviceModel.id : ''
            this.form.deviceProtocolId = response.payload.deviceProtocol ? response.payload.deviceProtocol.id : ''
            this.form.customerSim = response.payload.customerSim
            this.form.enabled = response.payload.enabled
            this.form.automaticVideoDownload = response.payload.automaticVideoDownload
            this.form.dataToCapture = bitFlagToArray(response.payload.dataToCapture)

            this.form.fleet = response.payload.fleet
            this.form.organization = response.payload.organization
            this.form.vehicle = response.payload.vehicle
            this.formFleet.fleet = response.payload.fleet
            this.formOrganization.organization = response.payload.organization
            if (response.payload.vehicle) response.payload.vehicle.registrationNumber = response.payload.vehicle.name
            this.formVehicle.vehicle = response.payload.vehicle

            this.isLoading = false
        },
        async editDevice (form) {
            this.isLoading = true
            const response = await deviceApi.editDevice({
                id: this.uuid,
                dataToCapture: arrayToBitFlag(form.dataToCapture),
                channelFlag: arrayToBitFlag(form.channels),
                deviceModelId: form.deviceModelId,
                deviceProtocolId: form.deviceProtocolId,
                firmwareVersion: form.firmwareVersion ? form.firmwareVersion : null,
                simNumber: form.simNumber ? form.simNumber : null,
                serialNumber: form.serialNumber ? form.serialNumber : null,
                customerSim: form.customerSim,
                enabled: form.enabled,
                automaticVideoDownload: form.automaticVideoDownload
            })

            if (!response.isSuccess) {
                this.isLoading = false
                return
            }

            this.isLoading = false
            toast.success('Device successfully updated.')
        },
        async validateOrganization () {
            this.validOrganization = this.$refs.formOrganization.validate()
            if (!this.validOrganization) return false
            if (this.formOrganization.organization || null) {
                const response = await deviceApi.assignDeviceToOrganization(this.uuid, this.formOrganization.organization.id)

                if (!response.isSuccess) {
                    return
                }
                this.form.organization = this.formOrganization.organization
                toast.success('The device has been assigned to organization.')
            } else {
                const response = await deviceApi.unassignDeviceFromOrganization(this.uuid)
                if (!response.isSuccess) {
                    return
                }
                this.form.organization = this.formOrganization.organization
                toast.success('The device has been unassigned from organization.')
            }
        },
        async validateFleet () {
            this.validFleet = this.$refs.formFleet.validate()
            if (!this.validFleet) {
                return false
            }

            if (this.formFleet.fleet || null) {
                const response = await deviceApi.assignDeviceToFleet(this.uuid, this.formFleet.fleet.id)

                if (!response.isSuccess) {
                    return
                }
                this.form.fleet = this.formFleet.fleet
                toast.success('The device has been assigned to fleet.')
            } else {
                const response = await deviceApi.unassignDeviceFromFleet(this.uuid)
                if (!response.isSuccess) {
                    return
                }
                this.form.fleet = this.formFleet.fleet
                toast.success('The device has been unassigned from fleet.')
            }
        },
        async validateVehicle () {
            this.validVehicle = this.$refs.formVehicle.validate()
            if (!this.validVehicle) {
                return false
            }

            if (this.formVehicle.vehicle || null) {
                const response = await deviceApi.assignDeviceToVehicle(this.uuid, this.formVehicle.vehicle.id)

                if (!response.isSuccess) {
                    return
                }
                this.form.vehicle = this.formVehicle.vehicle
                toast.success('The device has been assigned to vehicle.')
            } else {
                const response = await deviceApi.unassignDeviceFromVehicle(this.uuid)
                if (!response.isSuccess) {
                    return
                }
                this.form.vehicle = this.formVehicle.vehicle
                toast.success('The device has been unassigned from vehicle.')
            }
        }
    }
}
</script>

<style scoped>
    .organization-autocomplete {
        margin-bottom: 28px;
    }
</style>
